import type { ActiveRequest, TableConfig } from "../../../types/tables";

import { createActionsColumn } from "../../helpers/actionsColumn";
import {
  brandCell,
  createdByCell,
  dateCell,
  dueDateCellColored,
  nameCell,
  requestDesignTypeCell,
  statusCell,
} from "../../helpers/commonCells";

// Active Tab Configuration
export const activeTableConfig: TableConfig<ActiveRequest> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: 220,
    },
    {
      accessor: "customerDueDate",
      cellRenderer: dueDateCellColored,
      header: "Due",
      key: "customerDueDate",
      sortable: true,
      width: 120,
    },
    {
      accessor: "status",
      cellRenderer: statusCell,
      header: "Status",
      key: "status",
      sortable: true,
      width: 180,
    },
    {
      accessor: "brand",
      cellRenderer: brandCell,
      header: "Brand",
      key: "brand",
      sortable: true,
      width: 160,
    },
    {
      accessor: "createdBy",
      cellRenderer: createdByCell,
      header: "Created by",
      key: "createdBy",
      sortable: true,
      width: 140,
    },
    {
      accessor: "lastActivity",
      cellRenderer: dateCell,
      header: "Modified date",
      key: "lastActivity",
      sortable: true,
      width: 140,
    },
    {
      accessor: "requestType",
      cellRenderer: requestDesignTypeCell,
      header: "Request/Design type",
      key: "requestType",
      sortable: true,
      width: 180,
    },
    createActionsColumn<ActiveRequest>(["duplicate", "copyLink"]),
  ],
  defaultSort: {
    column: "createdAt",
    direction: "desc",
  },
  enableSorting: true,
  id: "active-requests",
  title: "Active Requests",
};
